import { FC, useState } from "react";
import CustomPopup from "../../../../custom-components/CustomPopup";
import { useTranslation } from "react-i18next";
import DeleteTrashIconSVG from "../../../resources/svg/DeleteTrashIconSVG";
import { useAppDispatch } from "../../../../custom-hooks/useAppDispatch";
import { UserServiceImpl } from "../../../../services/UserServiceImpl";

const DeleteAccount: FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const deleteUserHandler = async () => {
        setIsVisible(false);
        await dispatch(UserServiceImpl.deleteUserThunk());
        window.location.reload();
    };

    return (
        <CustomPopup
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            wrapClassName="dmin2:min-w-[628px] di6:min-w-[428px] ti6:min-w-[428px] ti7:min-w-[340px] tmax4:min-w-[340px]"
            confirmTitle={t("common.yes")}
            confirmHandler={deleteUserHandler}
            confirmButtonClassName="bg-transparent hover:bg-transparent w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mr-8 dmax2:mr-6 mt-8 dmax2:mt-6"
            cancelTitle={t("common.no")}
            cancelButtonClassName="w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
            skipScrollUnlock
            buttonElement={
                <div
                    className="flex items-center mt-4 tmax4:mt-5 cursor-pointer group"
                    onClick={() => setIsVisible(true)}
                >
                    <DeleteTrashIconSVG className="mr-2 text-textFaded group-hover:text-textWhite transition-all duration-300" />
                    <span className="H16 tmax4:H14 text-textFaded group-hover:text-textWhite transition-all duration-300">
                        {t("userProfile.editProfile.deleteAccount")}
                    </span>
                </div>
            }
        >
            <p className="H20 dmax2:H16 text-textWhite text-center mt-[10px] dmin2:max-w-[420px] di6:max-w-[340px] ti6:max-w-[340px] ti7:max-w-[280px] tmax4:max-w-[280px] break-words">
                {t("userProfile.editProfile.deletionAssurance")}
            </p>
        </CustomPopup>
    );
};

export default DeleteAccount;
